
import React from 'react';
import Layout from '@/components/layout/Layout';
import FarmFormComponent from '@/components/farms/FarmForm';

const FarmForm: React.FC = () => {
  return (
    <Layout>
      <FarmFormComponent />
    </Layout>
  );
};

export default FarmForm;
